import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import QuestionTable from "./Component/QuestionTable"


const Question =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <QuestionTable />
        </div>
        <Footer />
        </>
    )
}

export default Question